import './style/index.less';
import CustomComponents from './CustomComponents';

export default CustomComponents;
